import React from 'react';
import { FormControl, FormHelperText, FormLabel, Paper, Typography } from '@mui/material';
import { BrokerGroupSelect } from '@/components/selects/BrokerGroupSelect';

/**
 * Drawer field for choosing which broker groups an AI template is shared with.
 * Master templates are read-only and show a fallback message instead.
 */
export const AiTemplateShareDrawerField = ({
	labels,
	templateMaster = false,
	templateBrokerGroupIds,
	onTemplateBrokerGroupIdsChange,
	disabled = false,
	showAdmin = false,
}) => {
	if (templateMaster) {
		return (
			<Paper variant='outlined' sx={{ p: 2 }}>
				<Typography variant='body2'>{labels.masterFallbackLabel}</Typography>
			</Paper>
		);
	}

	return (
		<Paper variant='outlined' sx={{ p: 2 }}>
			<FormControl fullWidth disabled={disabled}>
				<FormLabel>{labels.shareGroupsLabel}</FormLabel>
				<FormHelperText sx={{ marginLeft: 0, marginBottom: 1 }}>
					{labels.shareGroupsHelper}
				</FormHelperText>
				<BrokerGroupSelect
					brokerGroupId={templateBrokerGroupIds}
					onChange={onTemplateBrokerGroupIdsChange}
					multiple={true}
					showAdmin={showAdmin}
					groupBy='ledger'
				/>
			</FormControl>
		</Paper>
	);
};
